if ( typeof CSSSliderNavigation !== 'function' ) {

  class CSSSliderNavigation extends HTMLElement {

    connectedCallback(){
      this.slider = document.getElementById(`slider-${this.dataset.sliderId}`);
      if ( this.slider ) {
        this.bind();
      } else {
        this._retry = setTimeout(() => {
          this.slider = document.getElementById(`slider-${this.dataset.sliderId}`);
          if ( this.slider && this.isConnected ) this.bind();
        }, 1000);
      }
    }

    disconnectedCallback(){
      clearTimeout(this._retry);
      this._abort?.abort();
    }

    bind(){
      this._abort?.abort();
      this._abort = new AbortController();
      const signal = this._abort.signal, slider = this.slider;

      this.prevButton = this.querySelector('[data-js-slider-prev]');
      this.nextButton = this.querySelector('[data-js-slider-next]');
      this.indexElement = this.querySelector('[data-js-slider-index]');
      this.lengthElement = this.querySelector('[data-js-slider-length]');
      this.pagination = this.querySelector('[data-js-slider-pagination]');

      this.prevButton?.addEventListener('click', () => slider.changeSlide('prev'), { signal });
      this.nextButton?.addEventListener('click', () => slider.changeSlide('next'), { signal });
      this.pagination?.addEventListener('click', e => {
        const dot = e.target.closest('[data-index]');
        if ( dot ) slider.changeSlide(dot.dataset.index);
      }, { signal });
      this.pagination?.addEventListener('keydown', e => {
        if ( ( e.key === 'Enter' || e.key === ' ' ) && e.target.matches('[data-index]') ) {
          e.preventDefault();
          e.target.click();
        }
      }, { signal });

      // Native change events from inputs inside the slides bubble through the slider too.
      slider.addEventListener('change', e => { if ( e.target === slider ) this.render(); }, { signal });
      const rebuild = e => { if ( e.target === slider ) this.render(true); };
      slider.addEventListener('ready', rebuild, { signal });
      slider.addEventListener('reset', rebuild, { signal });

      if ( slider.sliderEnabled ) this.render(true);
    }

    render(rebuild = false){
      const { index = 0, length = 0 } = this.slider;

      if ( rebuild ) {
        if ( this.hasAttribute('style') ) this.removeAttribute('style');
        this.classList.toggle('kt-hide', length <= 1);
        this.setText(this.lengthElement, length);
        if ( this.pagination && this.pagination.children.length !== length ) this.buildPagination(length);
      }

      this.setDisabled(this.prevButton, index <= 0);
      this.setDisabled(this.nextButton, index >= length - 1);
      this.setText(this.indexElement, index + 1);

      if ( this.pagination ) {
        Array.from(this.pagination.children).forEach((dot, i) => {
          dot.classList.toggle('kt-active', i === index);
          if ( i === index ) {
            if ( ! dot.hasAttribute('aria-current') ) dot.setAttribute('aria-current', 'true');
          } else if ( dot.hasAttribute('aria-current') ) {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    // Same-value writes still count as mutations, which wake style invalidation and page-wide observers.
    setText(el, value){
      if ( el && el.textContent !== String(value) ) el.textContent = value;
    }

    buildPagination(length){
      const label = window.KROWN.settings.locales.slider_thumbnail_label;
      const dots = Array.from({ length }, (_, i) => {
        const dot = document.createElement('span');
        dot.className = 'kt-css-slider-dot';
        dot.dataset.index = i;
        dot.setAttribute('aria-label', label.replace('{{ count }}', i + 1));
        dot.setAttribute('role', 'button');
        dot.setAttribute('tabindex', 0);
        return dot;
      });
      this.pagination.replaceChildren(...dots);
      this.pagination.style.setProperty('--size', length);
    }

    setDisabled(button, disabled){
      if ( ! button ) return;
      button.classList.toggle('kt-disabled', disabled);
      if ( button.getAttribute('aria-disabled') !== String(disabled) ) button.setAttribute('aria-disabled', disabled);
    }

  }

  if ( typeof customElements.get('css-slider-navigation') == 'undefined' ) {
    customElements.define('css-slider-navigation', CSSSliderNavigation);
  }

}
